<template>
  <div class="col-lg-5 col-md-12 col-sm-12 mb-4">
    <div class="card card-small blog-comments">
      <div class="card-header border-bottom">
        <h6 class="m-0">Mensajes</h6>
      </div>

      <div class="card-body p-0 border-bottom" v-for="(person, index) in messages" :key="index">
        <div class="blog-comments__item d-flex p-3">
          <div class="blog-comments__avatar mr-3">
            <img src="/images/avatars/unknown-user.png" alt="User avatar"/> </div>
          <div class="blog-comments__content">
            <div class="blog-comments__meta text-muted">
              <a class="text-secondary" :href="'mailto:' + person.email">
                {{ person.names }} {{ person.lastnames }}
              </a>
              <span class="text-muted">
                - <days-passed :date="person.created_at"/>
              </span>
            </div>
            <p class="m-0 my-1 mb-2 text-muted">
              {{ person.message }}
            </p>
          </div>
        </div>
      </div> 

      <div class="blog-comments__item d-flex p-3" v-if="messages.length == 0">
        No tienes mensajes
      </div>

      <div class="card-footer">
        <div class="row">
          <div class="col text-center view-report">
            <router-link class="btn btn-white" to="/mensajes">
            	Ver todos los mensajes
          	</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				messages: []
			}
		},

		mounted() {
			this.getMessages();
		},

		methods: {
			async getMessages() {
				let url = process.env.VUE_APP_ROOT_API.concat('/contact/card');
				let response = await fetch(url);
				this.messages = await response.json();
			}
		}
	}
</script>